import { useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

export function useTrackProgress(type, id) {
  useEffect(() => {
    if (!type || !id) return;

    const trackView = async () => {
      const token = localStorage.getItem('token');
      if (!token) return; // Only track for logged in users

      try {
        await axios.post(
          `${API}/progress/track?item_type=${type}&item_id=${id}`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
          }
        );
      } catch (error) {
        // Silently fail - tracking is non-critical
        console.debug('Progress tracking failed:', error);
      }
    };

    trackView();
  }, [type, id]);
}
